
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return require("private-next-pages/news/index.js");
      }
    ]);
  